import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconDownsize: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="downsize, exit-full-screen, scale-down"><path d="M3.75 9.25H9.25V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 9.25H14.75V3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14.75 20.25V14.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 14.75H9.25V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconDownsize;
